import React from 'react'
import { motion } from 'framer-motion'

const Services: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6 px-4">
            Our Services
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto px-4">
            Comprehensive physiotherapy solutions for every need
          </p>
        </motion.div>

        <div className="space-y-16">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12"
          >
            <div className="card p-5 sm:p-6 lg:p-8">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6">Clinic-Based Treatment</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                State-of-the-art facilities with advanced equipment including:
              </p>
              <ul className="space-y-2 text-gray-600 dark:text-gray-300">
                <li>• Advanced assessment methods and proper diagnosis</li>
                <li>• Advanced therapeutic equipment</li>
                <li>• Well-managed treatment area</li>
                <li>• Treadmill for sports persons and athletes</li>
                <li>• Laser therapy treatment</li>
              </ul>
            </div>
            
            <div className="card p-5 sm:p-6 lg:p-8">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6">Home Care Services</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Professional physiotherapy in the comfort of your home:
              </p>
              <ul className="space-y-2 text-gray-600 dark:text-gray-300">
                <li>• Convenient scheduling</li>
                <li>• Portable equipment</li>
                <li>• Family involvement</li>
                <li>• Personalized environment</li>
                <li>• Reduced travel stress</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8"
          >
            {[
              { title: 'Physiotherapy', desc: 'Evidence-based care for pain, mobility, and functional recovery.' },
              { title: 'Advanced physiotherapy', desc: 'Advanced treatment methods tailored to complex conditions.' },
              { title: 'Neurological conditions rehabilitation', desc: 'Specialized programs for stroke, Parkinson\'s, and other neurological conditions.' },
              { title: 'Sports injury rehabilitation', desc: 'Return-to-sport protocols and performance-focused recovery.' },
              { title: 'Geriatric rehabilitation', desc: 'Balance, strength, and independence-focused programs for seniors.' },
              { title: 'Home care rehabilitation', desc: 'Professional physiotherapy delivered at home with personalized plans.' },
              { title: 'Tele-rehab/ online consultations', desc: 'Virtual consultations and remote guidance for convenient care.' }
            ].map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="card p-5 sm:p-6 text-center"
              >
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white mb-3 sm:mb-4">{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300 leading-relaxed">{service.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Services
